















import Vue from 'vue'
import NewsEntity from '@/entities/News'
import CommonArrow from '@/components/shared/atoms/Icon/CommonArrow'

export default Vue.extend({
  components: {
    CommonArrow
  },
  props: {
    newsData: {
      type: Object as () => NewsEntity,
      required: true
    }
  },
  methods: {
    setCategoryClass(category: number): string {
      switch (category) {
        case 1:
          return 'release'
        case 2:
          return 'important'
        case 3:
          return 'info'
        default:
          return ''
      }
    }
  }
})
